export default "__VITE_ASSET__lym_XiLO__"